<template>
  <div class="market-invitingFriends-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #date="{ row }">{{ row.date || '---' }}</template>
      <template #nameCardUV="{ row }">{{ row.nameCardUV || '0' }}</template>
      <template #nameCardPV="{ row }">{{ row.nameCardPV || '0' }}</template>
      <template #savePosterNum="{ row }">{{ row.savePosterNum || '0' }}</template>
      <template #shareNameCardUrlNum="{ row }">{{ row.shareNameCardUrlNum || '0' }}</template>
      <template #shareNameCardUrlTotalNum="{ row }">{{ row.shareNameCardUrlTotalNum || '0' }}</template>
      <template #shareInviteFriendsUrlUV="{ row }">{{ row.shareInviteFriendsUrlUV || '0' }}</template>
      <template #shareInviteFriendsUrlPV="{ row }">{{ row.shareInviteFriendsUrlPV || '0' }}</template>
      <template #fillInInviterNum="{ row }">{{ row.fillInInviterNum || '0' }}</template>
      <template #inviteFriendsSuccessNum="{ row }">{{ row.inviteFriendsSuccessNum || '0' }}</template>
      <template #newUsersOfPlatformNum="{ row }">{{ row.newUsersOfPlatformNum || '0' }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getInviteActivityRecordList } from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "marketInvitingFriendsIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table
  },
  data() {
    const startDate = this.$moment().subtract(7, 'days').valueOf() //默认开始时间
    const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
    return {
      renderData: [
        {
          label: "起止时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
      ],

      form: {
         time:[startDate,endDate]
      },
      tableThData: [
        { prop: "date", label: "日期", minWidth: "120", },
        { prop: "nameCardUV", label: "我的名片页UV", minWidth: "120", },
        { prop: "nameCardPV", label: "我的名片页PV", minWidth: "180", },
        { prop: "savePosterNum", label: "保存海报人数", minWidth: "120", },
        { prop: "shareNameCardUrlNum", label: "分享名片链接人数", minWidth: "180", },
        { prop: "shareNameCardUrlTotalNum", label: "分享名片链接总次数", minWidth: "150", },
        { prop: "shareInviteFriendsUrlUV", label: "分享邀友落地页UV", minWidth: "150", },
        { prop: "shareInviteFriendsUrlPV", label: "分享邀友落地页PV", minWidth: "150", },
        { prop: "fillInInviterNum", label: "手填邀请人总数", minWidth: "120", },
        { prop: "inviteFriendsSuccessNum", label: "邀友成功总数", minWidth: "120", },
        { prop: "newUsersOfPlatformNum", label: "平台新增用户数", minWidth: "120", },
      ],
    };
  },
  created () {},
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.beginTime = this.form.time ? this.form.time[0] : this.$moment().subtract(7, 'days').valueOf()
      params.endTime = this.form.time ? this.form.time[1] : this.$moment().subtract(0, 'days').valueOf()
      delete params.time
      let data = await api_getInviteActivityRecordList(params)
      this.total = data.length
      this.tableTrData = data.slice(this.offset,this.offset+this.limit)
      this.loading = false
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-invitingFriends-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    .down-btn {
      padding: 0 10px;
    }
  }

  .copy {
    color: #05C8AF;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
